import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Grid,
  Group,
  Input,
  Menu,
  MultiSelect,
  MultiSelectProps,
  rem,
  Select,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import {
  IconArrowRight,
  IconBarcode,
  IconBuildingWarehouse,
  IconCaretDown,
  IconEye,
  IconFileExport,
  IconMapPin,
  IconPlus,
  IconSearch,
  IconTrash,
  IconX,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { useForm } from "@mantine/form";
import { _localization } from "../../../config/location";
import BreadCrumb from "../../../_base/component/_layout/_breadcrumb";
import axios from "axios";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { modals } from "@mantine/modals";
import { MessageResponse } from "../../../model/MessageResponse";
import { IconEdit } from "@tabler/icons-react";
import { API_ROUTE } from "../../../const/apiRoute";
import Repository from "../../../_base/helper/HttpHelper";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import DeleteProductSelected from "./ModalProductSelected/DeleteProductSelected";
import CreateProductCategoryView from "./CreateView";
interface SearchCriteria {
  keySearch?: string;
  status?: string;
  paymentMethod?: string;
  invoiceType?: string;
}
type ProductSelected = {
  idItems: (number | string)[];
  onClose: any;
  fetchDataList: () => void;
};
type FacebookAdProduct = {
  id: number;
  fbAdsId: number;
  productId: number;
  productCode: string;
  productionName: string;
  imageUrl: string | null;
  url: string;
  price: number;
  warranty: string;
  createBy: string | null;
  createTime: string | null;
  creationDate: string;
  createdBy: number;
  lastUpdateDate: string | null;
  lastUpdatedBy: string | null;
};

const ProductSelecteds = ({
  idItems,
  onClose,
  fetchDataList,
}: ProductSelected) => {
  // Khởi tạo component InventoryReportList
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  type Search = string | number | boolean | object | null;
  const [searchs, setSearchs] = useState<Search>(null);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const [data, setData] = useState<FacebookAdProduct[]>([]);
  const [rowCount, setRowCount] = useState(0);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [editViewProduct, setEditViewProduct] = useState(false);
  const form = useForm<SearchCriteria>({
    mode: "uncontrolled",
    initialValues: {},
  });

  const formatCurrencyVND = (value: any) => {
    if (value == null) {
      return "";
    }
    // Định dạng số theo chuẩn Việt Nam
    return value.toLocaleString("vi-VN", {
      minimumFractionDigits: 0, // Không hiển thị phần thập phân
      maximumFractionDigits: 0, // Đảm bảo không có chữ số sau dấu phẩy
    });
  };
  const styleTableMantine = {
    paddingLeft: "12px",
    paddingRight: "12px",
  };

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 50,
      },
      {
        accessorKey: "productCode",
        header: "Mã sản phẩm",
      },
      {
        accessorKey: "productionName",
        header: "Tên sản phẩm",
        size: 300,
        minSize: 300,
      },
      {
        accessorKey: "price",
        header: "Giá",
        Cell: ({ renderedCellValue }: any) => (
          <Text size="sm" fw={700} c="blue" ml={10}>
            {formatCurrencyVND(renderedCellValue)}
          </Text>
        ),
        size: 135,
      },
      {
        accessorKey: "warranty",
        header: "Bảo hành",
      },
      {
        accessorKey: "url",
        header: "Đường dẫn",
        minSize: 600,
      },
      {
        accessorKey: "action",
        header: "Thao tác ",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableResizing: false,
        size: 100,
        Cell: ({ row }) => (
          <Box style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Tooltip label="Xóa">
              <ActionIcon
                variant="light"
                color="red"
                onClick={async () => {
                  await deleteData([row.original.id], row.original.fbAdsId);
                }}
              >
                <IconTrash size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Box>
        ),
      },
    ],
    []
  );

  // Hàm lấy dữ liệu
  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);

    try {
      const search = form.getValues();

      const queryParams = new URLSearchParams();

      if (search && search.keySearch) {
        queryParams.append("KeySearch", search.keySearch);
      }

      if (pagination) {
        queryParams.append(
          "Skip",
          String(pagination.pageIndex * pagination.pageSize)
        );
        queryParams.append("Take", String(pagination.pageSize));
      }

      const url = `${
        API_ROUTE.GET_LIST_PRODUCT_SELECTED
      }?FbAdsId=${idItems}&${queryParams.toString()}`;
      const response = await repository.get(url);
      if (response) {
        let result = response.data.lists;
        setData(result);
        setRowCount(response.data.count);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };
  const deleteData = async (ids: number[], idFbAds: number) => {
    if (ids.length < 1) NotificationExtension.Warn("Bạn chưa chọn dữ liệu !");
    else
      try {
        modals.openConfirmModal({
          title: (
            <>
              <Title order={5}>Xóa dữ liệu này!</Title>
            </>
          ),
          size: "550px",
          children: (
            <DeleteProductSelected
              idItems={ids}
              idFbAds={idFbAds}
              onClose={setDeleteViewStatus}
              fetchDataList={fetchDataList}
            />
          ),
          confirmProps: { display: "none" },
          cancelProps: { display: "none" },
        });
      } catch (error) {
        console.error(error);
        return;
      }
  };

  const CreateItem = async () => {
    modals.open({
      size: "lg",
      title: <Title order={5}>Thêm mới danh mục</Title>,
      children: (
        <CreateProductCategoryView
          onClose={() => setDeleteViewStatus((prev) => !prev)}
        />
      ),
    });
  };

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    rowCount,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    // manualPagination: true,

    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    enableStickyFooter: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT", "invoiceNum"],
        right: ["action1", "action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    getRowId: (row) => row.id,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    enableRowSelection: true,
    onRowSelectionChange: (updater) => {
      const newSelection =
        typeof updater === "function" ? updater(rowSelection) : updater;

      setRowSelection(newSelection);

      // merge selection toàn cục
      const newlySelectedIds = Object.entries(newSelection)
        .filter(([_, isSelected]) => isSelected)
        .map(([rowId]) => Number(rowId));

      setSelectedIds((prev) => {
        const merged = new Set([...prev, ...newlySelectedIds]);
        const currentPageIds = data.map((d) => d.id);
        currentPageIds.forEach((id) => {
          if (!newlySelectedIds.includes(id)) {
            merged.delete(id);
          }
        });
        return Array.from(merged);
      });
    },
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,

    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
      siblings: 1,
      boundaries: 1,
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (220 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);
  useEffect(() => {
    fetchData();
  }, [pagination, deleteViewStatus, editViewProduct]);
  return (
    <Box>
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Box style={{ display: "flex", justifyContent: "space-between" }}>
          <Grid mt={10}>
            <Grid.Col
              style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
            >
              <Input
                placeholder="Nhập tìm kiếm"
                key={form.key("keySearch")}
                type="text"
                leftSection={<IconSearch size={"20"} color="#15aabf" />}
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    await fetchData();
                  }
                }}
                {...form.getInputProps("keySearch")}
              />
              <Button
                color="blue"
                variant="outline"
                onClick={async () => {
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>

          <Button
            mt={10}
            mr={10}
            leftSection={<IconTrash size={20} stroke={1.5} />}
            color="red"
            variant="outline"
            onClick={async () => {
              const fbAdsId = data[0]?.fbAdsId ?? 0;
              await deleteData(selectedIds, fbAdsId);
            }}
          >
            Xóa
          </Button>
        </Box>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </Box>
  );
};

export default ProductSelecteds;
